import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { HttpService } from '../service/http.service';
import { SelectItem } from 'primeng/api';
import { PaymentToSchoolListItem } from '../payment-to-school-list-item';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-transactions-payment-to-school',
  templateUrl: './transactions-payment-to-school.component.html',
  styleUrls: ['./transactions-payment-to-school.component.css']
})
export class TransactionsPaymentToSchoolComponent implements OnInit {

  @ViewChild('dataTable') table!: Table;
  @ViewChild("idInput") idInput!: ElementRef;
  @ViewChild("studentNameInput") studentNameInput!: ElementRef;
  @ViewChild("invoiceNumberInput") invoiceNumberInput!: ElementRef;
  @ViewChild("commentInput") commentInput!: ElementRef;
  @ViewChild("amountInput") amountInput!: ElementRef;
  @ViewChild("schoolNameInput") schoolNameInput!: ElementRef;
  @ViewChild("paidMonthInput") paidMonthInput!: ElementRef;

  years: SelectItem[] = [];
  currencyIsoCodes: SelectItem[] = [];
  selectedCurrencyIsoCodes: string[] = [];
  payments: PaymentToSchoolListItem[] = [];

  constructor(
    private httpService: HttpService
  ){}

  ngOnInit(): void {
    let thisYear = moment().year();
    for (let i = 0; i < 5; i++) {
      let oldYear = thisYear - i;
      this.years.push({ label: oldYear.toString(), value: oldYear });
    }
    this.httpService.getCurrencies().subscribe(res => {
      this.currencyIsoCodes = [];
      for (let currency of res) {
        this.currencyIsoCodes.push({ label: currency.isoCode, value: currency.isoCode });
      }
    });
    this.refreshData(thisYear);
  }

  refreshData(year: number) {
    this.httpService.getPaymentToSchoolListItemsByYear(year).subscribe(res => {
      this.payments = res;
    });
  }

  changeYear(value: number) {
    this.refreshData(value);
  }

  onPaymentDateSelect(value: Date) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), 'paidDate', 'equals');
  }

  onStartDateSelect(value: Date) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), 'startDate', 'equals');
  }
}
